'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002412 from "./presto.-Login-Page-View$$anon$12.js";
import * as $j_presto$002etypes$0024$002dCompact$002dGroup$0024 from "./presto.types$-Compact-Group$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$11() {
  this.b6b = null;
  this.b63 = null;
  this.b64 = false;
  this.b6c = null;
  this.b6d = false;
  this.b6g = null;
  this.b69 = null;
  this.b6a = false;
  this.b65 = null;
  this.b66 = false;
  this.b67 = null;
  this.b68 = false;
  this.b6e = false;
  this.b6f = false;
  this.b6b = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b6g = "CompactGroup";
}
export { $c_Lpresto_LoginPageView$$anon$11 as $c_Lpresto_LoginPageView$$anon$11 };
$p = $c_Lpresto_LoginPageView$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$11;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$11() {
}
export { $h_Lpresto_LoginPageView$$anon$11 as $h_Lpresto_LoginPageView$$anon$11 };
$h_Lpresto_LoginPageView$$anon$11.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.b6b;
});
$p.M = (function() {
  if ((!this.b64)) {
    this.b63 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b64 = true;
  }
  return this.b63;
});
$p.O = (function() {
  if ((!this.b6d)) {
    this.b6c = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b6d = true;
  }
  return this.b6c;
});
$p.D = (function() {
  return this.b6g;
});
$p.t = (function() {
  if ((!this.b6a)) {
    this.b69 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b6a = true;
  }
  return this.b69;
});
$p.N = (function() {
  if ((!this.b66)) {
    this.b65 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iQ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kF())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b66 = true;
  }
  return this.b65;
});
$p.Q = (function() {
  if ((!this.b68)) {
    this.b67 = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002412.$c_Lpresto_LoginPageView$$anon$12();
    this.b68 = true;
  }
  return this.b67;
});
$p.v = (function() {
  if ((!this.b6f)) {
    this.b6e = false;
    this.b6f = true;
  }
  return this.b6e;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee85) => ((p) => \u03b4scrutinee85.adF(p)))($j_presto$002etypes$0024$002dCompact$002dGroup$0024.$m_Lpresto_types$CompactGroup$())));
});
var $d_Lpresto_LoginPageView$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$11, "presto.LoginPageView$$anon$11", ({
  Mb: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$11 as $d_Lpresto_LoginPageView$$anon$11 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$11.js.map
